import { FormControl, Select, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormControl = styled(FormControl)(() => ({}));

export const StyledPhoneTextField = styled(TextField)(
  ({ theme, value, size }) => ({
    color: theme.palette.custom.black[90],
    lineHeight: '100%',

    ...(size === 'medium' && {
      '& .MuiOutlinedInput-root': {
        height: '52px',
        borderRadius: '14px',
      },

      '& .MuiOutlinedInput-input': {
        paddingLeft: 0,
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingRight: '14px',
      },
    }),

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.custom.black[!value ? 10 : 90],
      borderRadius: '14px',
    },

    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.custom.black[30],
      opacity: 1,
    },

    '&:hover:not(.Mui-disabled)': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.black[30],
      },
    },

    '&.Mui-error': {
      color: theme.palette.error.main,

      '& .MuiInputBase-input::placeholder': {
        color: theme.palette.error.main,
      },
    },

    '&.Mui-disabled': {
      borderRadius: '14px',
      backgroundColor: theme.palette.custom.grey3,
      borderColor: theme.palette.custom.black[20],
    },

    '& .MuiTelInput-IconButton': {
      backgroundColor: theme.palette.custom.grey6,
      borderRadius: '100%',
      padding: '4px 8px',
      marginRight: '4px',
      transition: 'background-color 0.2s ease',

      '&:hover': {
        backgroundColor: theme.palette.custom.grey2,
      },
    },
  })
);

export const StyledCountrySelect = styled(Select)(
  () => `

    & .MuiPaper-root {
      width: 210px;
      height: 340px;
    }

    & .MuiSelect-select {
      padding: 8px !important;
      padding-right: 24px !important;
    }
    
    fieldset {
      display: none;
    }

    svg {
      right: 0;
    }
  `
);
